import {
  Examination_Type,
  ExaminationListQueryVariables,
  PlatformExaminationListOrderFields,
} from "@generated/graphql";
import TrialsReminderSendButton from "components/buttons/TrialsReminderSendButton";
import examinationListBaseColumnConfig from "components/ExaminationList/config/columnConfig";
import { ExaminationItem } from "components/ExaminationList/types";
import { ColumnConfig, RouteEnum } from "layout/TableConstructor/types";

const columnConfig: ColumnConfig<
  ExaminationItem,
  NonNullable<ExaminationListQueryVariables["filter"]>,
  PlatformExaminationListOrderFields,
  "trials",
  RouteEnum.Examination
>[] = [
  ...examinationListBaseColumnConfig,
  {
    title: "Напоминание",
    name: "reminderSend",
    render: (data) => {
      return data.type === Examination_Type.Group ? <TrialsReminderSendButton examination={data} /> : "";
    },
    renderCollapse: (data) => {
      return data.examination.type === Examination_Type.Group ? (
        <TrialsReminderSendButton
          examination={data.examination}
          trial={data}
        />
      ) : (
        ""
      );
    },
  },
];

export default columnConfig;
